@if (showLoader) {
  <div class="loading-container"><app-loading></app-loading></div>
}

<div class="edit-page">
  <mat-drawer-container class="container">
    <mat-drawer #drawer class="sidenav new-nav item-editor-nav" mode="side" opened="isDrawerOpen" [disableClose]="true">
      <div class="edit-options">
        <div class="div-option" [ngClass]="{ 'coming-soon': !itemEditor }">
          @if (!itemEditor) {
            <div class="coming-soon-text">Coming Soon</div>
          }
          <div class="option-header">
            <div class="files-title option-title">
              Files
              <mat-icon
                matTooltip="Files can be attached to a room item, and will appear in the file library in the room"
                matTooltipPosition="right"
                class="info-icon"
              >
                info
              </mat-icon>
            </div>
            <div>
              <button mat-icon-button class="drop-button" (click)="handleOpenRoomFiles()">
                @if (openRoomFiles) {
                  <mat-icon>arrow_drop_down</mat-icon>
                } @else {
                  <mat-icon>arrow_drop_up</mat-icon>
                }
              </button>
            </div>
          </div>
          <div>
            <button type="button" mat-button class="add-button" (click)="openUploadFileDialog()">
              Add File <mat-icon class="add-icon">add</mat-icon>
            </button>
          </div>
          @if (openRoomFiles) {
            <div class="list-file" [ngClass]="{ 'list-overflow': addOverflowFiles }">
              @for (files of filesArray; track files.socialFileId) {
                <div class="file-info">
                  <div class="file-name">{{ files.fileName }}</div>
                  <div>
                    <mat-icon (click)="deleteFile(files.socialFileId)">close</mat-icon>
                  </div>
                </div>
              }
            </div>
          }
        </div>

        <div class="div-option" [ngClass]="{ 'coming-soon': !itemEditor }">
          @if (!itemEditor) {
            <div class="coming-soon-text">Coming Soon</div>
          }
          <div class="option-header">
            <div class="option-title">Rooms Items</div>
            <div>
              <button mat-icon-button class="drop-button" (click)="handleOpenRoomItems()">
                @if (openRoomItems) {
                  <mat-icon>arrow_drop_down</mat-icon>
                } @else {
                  <mat-icon>arrow_drop_up</mat-icon>
                }
              </button>
            </div>
          </div>

          <div>
            <button mat-button class="add-button" (click)="openItemCreatorModal()">
              Create Room Item <mat-icon class="add-icon">add</mat-icon>
            </button>
          </div>

          @if (openRoomItems) {
            <div class="list-item" [ngClass]="{ 'list-overflow': addOverflowItems }">
              @for (item of itemsArray; track item.CTAItemId) {
                <div class="item-info" [ngClass]="{ item_selected: checkItemSelected(item.CTAItemId) }">
                  <div class="item-name" (click)="selectCTAItemList(item.CTAItemId)">
                    <div class="icon"><mat-icon svgIcon="IMAGE_UPLOADED"></mat-icon></div>
                    <div class="name">{{ item.name }}</div>
                  </div>
                  <div class="item-options">
                    <button class="kebab-btn m-l-10" [matMenuTriggerFor]="menu">
                      <mat-icon class="kebab-menu-icon">more_horiz</mat-icon>
                    </button>
                    <mat-menu role="menu" #menu="matMenu" xPosition="before" class="saved-rooms-options-menu">
                      <button
                        type="button"
                        mat-menu-item
                        role="menuitem"
                        (click)="onDuplicateItem(item)"
                        data-testid="duplicate-button"
                      >
                        Duplicate
                      </button>
                      <button
                        type="button"
                        mat-menu-item
                        role="menuitem"
                        (click)="onEditItem(item)"
                        data-testid="edit-button"
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        mat-menu-item
                        role="menuitem"
                        (click)="onDeleteItem(item)"
                        data-testid="delete-button"
                      >
                        Delete
                      </button>
                    </mat-menu>
                  </div>
                </div>
              }
            </div>
          }
        </div>

        <div class="div-option">
          <div class="option-header">
            <div class="option-title">Room Configuration</div>
            <div>
              <button mat-icon-button class="drop-button" (click)="handleOpenRoomConfig()">
                @if (openRoomConfig) {
                  <mat-icon>arrow_drop_down</mat-icon>
                } @else {
                  <mat-icon>arrow_drop_up</mat-icon>
                }
              </button>
            </div>
          </div>
          @if (openRoomConfig) {
            <div class="room-info">
              <div class="info-option">
                <div>
                  <div class="info-title">Room name</div>
                  <div class="info-desc">{{ this.roomName }}</div>
                </div>
                <div>
                  <button mat-button class="add-button" (click)="redirectToEditStep('0')">Change</button>
                </div>
              </div>

              <div class="info-option">
                <div>
                  <div class="info-title">Room size</div>
                  <div class="info-desc">{{ this.roomSize?.label }}</div>
                </div>
                <div>
                  <button mat-button class="add-button" (click)="redirectToEditStep('1')">Change</button>
                </div>
              </div>

              <div class="info-option">
                <div>
                  <div class="info-title">Room background</div>
                  <div class="info-desc">{{ this.theme?.socialThemeName }}</div>
                </div>
                <div>
                  <button mat-button class="add-button" (click)="redirectToEditStep('3')">Change</button>
                </div>
              </div>

              <div class="info-option">
                <div>
                  <div class="info-title">Room music</div>
                  <div class="info-desc">{{ this.playlist?.name ?? 'None' }}</div>
                </div>
                <div>
                  <button mat-button class="add-button" (click)="redirectToEditStep('2')">Change</button>
                </div>
              </div>

              <div class="info-option">
                <div>
                  <div class="info-title">Room settings</div>
                </div>
                <div>
                  <button mat-button class="add-button" (click)="redirectToRoomSettings()">Change</button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </mat-drawer>

    <!-- Drawer Content -->
    <mat-drawer-content class="stepper-container" [ngClass]="{ 'item-editor': itemEditor }">
      @if (!itemEditor) {
        <div class="coming-soon-text">
          <div class="coming-soon-title">Coming Soon</div>
          <div class="coming-soon-desc">
            The room item editor is coming soon. In the meantime, you can configure our room settings in the room
            configuration panel to the left
          </div>
        </div>
      } @else {
        @if (theme) {
          <app-pixi-item-editor
            (itemSelected)="selectCTAItem($event)"
            [theme]="theme"
            [ctaItems]="itemsArray"
            [listItemSelectedId]="listItemSelectedId"
          ></app-pixi-item-editor>
        }
      }
    </mat-drawer-content>
  </mat-drawer-container>
</div>
